import React from "react";
import "./App.css";
import "./Portfolio.css";
import { BrowserRouter } from "react-router-dom";
import BrowserUI from "./components/BrowserUI";
import Portfolio from "./components/Portfolio";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <BrowserUI>
          <Portfolio />
        </BrowserUI>
      </BrowserRouter>
    </div>
  );
}

export default App;